import { ReducerBuilder } from './ReducerBuilder'

const INITIAL_STATE = {
  LOAD_APP_VITALS: true,
}
interface StateType {
  [key: string]: boolean
}

const ongoingAdd = (state: StateType, payload: string): StateType => ({ ...state, [payload]: true })

const ongoingRemove = (state: StateType, payload: string): StateType => {
  const { [payload]: removed, ...rest } = state
  return rest
}

const reducer = ReducerBuilder.create<StateType, string>(INITIAL_STATE)
  .mapAction('ONGOING_ADD', ongoingAdd)
  .mapAction('ONGOING_REMOVE', ongoingRemove)
  .build()

export default reducer
